export const generativeAiAppGroupIdDalleAssistant = "/:app_group_id/generative_ai/dalle_assistant";
